export enum UserRoleEnum {
  '루트 관리자' = 'ROOT',
  '최고 관리자' = 'ADMIN',
  '데이터 관리자' = 'MANAGER',
  '일반 회원' = 'NORMAL'
}

export enum ContactCountryCodeEnum {
  '대한민국 (+82)' = '+82',
  '베트남 (+84)' = '+84'
}
